import React from 'react';
import RecipeListElement from './RecipeListElement/RecipeListElement';

function RecipeList({ recipesArray, activateHandler}) {

    if (recipesArray.length === 0) {
        return (
            <div>
                <p>No matching recipes</p>
            </div>
        )
    }
    return (
        <ul className="recipes-list">
            {
                recipesArray.map((recipe, index) => {
                    return (<RecipeListElement recipe={recipe} key={index} index={index} onClick={activateHandler ? activateHandler : () => { } }/>)
                })
            }
        </ul>
    );
}

export default RecipeList